/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Label_PasswordInputs */

const en_auth_label_password = /** @type {(inputs: Auth_Label_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Password`)
};

const es_auth_label_password = /** @type {(inputs: Auth_Label_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contraseña`)
};

const de_auth_label_password = /** @type {(inputs: Auth_Label_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passwort`)
};

const zh_auth_label_password = /** @type {(inputs: Auth_Label_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`密码`)
};

const ar_auth_label_password = /** @type {(inputs: Auth_Label_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`كلمة المرور`)
};

const fr_auth_label_password = /** @type {(inputs: Auth_Label_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mot de passe`)
};

const vi_auth_label_password = /** @type {(inputs: Auth_Label_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mật khẩu`)
};

const sw_auth_label_password = /** @type {(inputs: Auth_Label_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenosiri`)
};

const th_auth_label_password = /** @type {(inputs: Auth_Label_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รหัสผ่าน`)
};

const bs_auth_label_password = /** @type {(inputs: Auth_Label_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lozinka`)
};

const ja_auth_label_password = /** @type {(inputs: Auth_Label_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パスワード`)
};

const ko_auth_label_password = /** @type {(inputs: Auth_Label_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`비밀번호`)
};

const pt_auth_label_password = /** @type {(inputs: Auth_Label_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senha`)
};

const it_auth_label_password = /** @type {(inputs: Auth_Label_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Password`)
};

const sv_auth_label_password = /** @type {(inputs: Auth_Label_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lösenord`)
};

const nl_auth_label_password = /** @type {(inputs: Auth_Label_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wachtwoord`)
};

const da_auth_label_password = /** @type {(inputs: Auth_Label_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adgangskode`)
};

const nb_auth_label_password = /** @type {(inputs: Auth_Label_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passord`)
};

const fi_auth_label_password = /** @type {(inputs: Auth_Label_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salasana`)
};

const pl_auth_label_password = /** @type {(inputs: Auth_Label_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hasło`)
};

const ru_auth_label_password = /** @type {(inputs: Auth_Label_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пароль`)
};

const tr_auth_label_password = /** @type {(inputs: Auth_Label_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Şifre`)
};

const hi_auth_label_password = /** @type {(inputs: Auth_Label_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पासवर्ड`)
};

const id_auth_label_password = /** @type {(inputs: Auth_Label_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kata sandi`)
};

const ms_auth_label_password = /** @type {(inputs: Auth_Label_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kata laluan`)
};

const cs_auth_label_password = /** @type {(inputs: Auth_Label_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heslo`)
};

const el_auth_label_password = /** @type {(inputs: Auth_Label_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Κωδικός πρόσβασης`)
};

const he_auth_label_password = /** @type {(inputs: Auth_Label_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`סיסמה`)
};

const af_auth_label_password = /** @type {(inputs: Auth_Label_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wagwoord`)
};

const hu_auth_label_password = /** @type {(inputs: Auth_Label_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jelszó`)
};

/**
* | output |
* | --- |
* | "Password" |
*
* @param {Auth_Label_PasswordInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const auth_label_password = /** @type {((inputs?: Auth_Label_PasswordInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Label_PasswordInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_auth_label_password(inputs)
	if (locale === "de") return de_auth_label_password(inputs)
	if (locale === "zh") return zh_auth_label_password(inputs)
	if (locale === "ar") return ar_auth_label_password(inputs)
	if (locale === "fr") return fr_auth_label_password(inputs)
	if (locale === "vi") return vi_auth_label_password(inputs)
	if (locale === "sw") return sw_auth_label_password(inputs)
	if (locale === "th") return th_auth_label_password(inputs)
	if (locale === "bs") return bs_auth_label_password(inputs)
	if (locale === "ja") return ja_auth_label_password(inputs)
	if (locale === "ko") return ko_auth_label_password(inputs)
	if (locale === "pt") return pt_auth_label_password(inputs)
	if (locale === "it") return it_auth_label_password(inputs)
	if (locale === "sv") return sv_auth_label_password(inputs)
	if (locale === "nl") return nl_auth_label_password(inputs)
	if (locale === "da") return da_auth_label_password(inputs)
	if (locale === "nb") return nb_auth_label_password(inputs)
	if (locale === "fi") return fi_auth_label_password(inputs)
	if (locale === "pl") return pl_auth_label_password(inputs)
	if (locale === "ru") return ru_auth_label_password(inputs)
	if (locale === "tr") return tr_auth_label_password(inputs)
	if (locale === "hi") return hi_auth_label_password(inputs)
	if (locale === "id") return id_auth_label_password(inputs)
	if (locale === "ms") return ms_auth_label_password(inputs)
	if (locale === "cs") return cs_auth_label_password(inputs)
	if (locale === "el") return el_auth_label_password(inputs)
	if (locale === "he") return he_auth_label_password(inputs)
	if (locale === "af") return af_auth_label_password(inputs)
	if (locale === "hu") return hu_auth_label_password(inputs)
	return en_auth_label_password(inputs)
});